import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UpdateAppService {

    constructor(private swUpdate: SwUpdate, private router: Router) {
        if (swUpdate.isEnabled) {
            console.log('✅ Service Worker activo - Iniciando verificaciones automáticas cada 30 segundos');
            interval(30000).subscribe(() => {
                swUpdate.checkForUpdate().catch(error => {
                    console.error('❌ Error verificando actualizaciones:', error);
                });
            });
        } else {
            console.log('❌ Service Worker NO habilitado (probablemente en desarrollo)');
        }
    }


    public checkForUpdates(): void {
        if (this.swUpdate.isEnabled) {
            console.log('✅ Service Worker disponible - Configurando listeners');
            this.swUpdate.available.subscribe(event => {
                console.log('🆕 Nueva versión disponible detectada:', event);
                this.updateApp();
            });

            this.swUpdate.activated.subscribe(event => {
                console.log('🎉 Aplicación actualizada exitosamente:', event);
            });

            this.swUpdate.checkForUpdate().catch(error => {
                console.error('❌ Error en verificación inicial:', error);
            });
        } else {
            console.log('❌ Service Worker no habilitado - No se pueden verificar actualizaciones');
            console.log('💡 Verifica que estés en producción y con HTTPS/localhost');
        }
    }



    private updateApp(): void {
        console.log('🔄 Iniciando proceso de actualización...');
        this.swUpdate.activateUpdate().then(() => {
            console.log('✅ Nueva versión activada - Limpiando caches...');
            this.clearAllCaches().then(() => {
                window.location.reload();
            });
        }).catch(error => {
            console.error('❌ Error al activar actualización:', error);
            this.clearAllCaches().then(() => {
                window.location.reload();
            });
        });
    }

    private async clearAllCaches(): Promise<void> {
        console.log('🧹 Iniciando limpieza de caches SW...');
        if ('caches' in window) {
            try {
                const cacheNames = await caches.keys();
                const deletePromises = cacheNames.map(cacheName => caches.delete(cacheName));
                await Promise.all(deletePromises);
                console.log('✅ Todos los caches SW eliminados exitosamente');
            } catch (error) {
                console.error('❌ Error limpiando caches:', error);
            }
        } else {
            console.log('❌ API de Cache no disponible en este navegador');
        }
    }
    
    public getServiceWorkerInfo(): Promise<void> {
        console.log('📊 === DIAGNÓSTICO COMPLETO DEL SERVICE WORKER ===');
        return fetch('/ngsw.json')
            .then(response => {
                console.log(response.ok ? '✅ ngsw.json ENCONTRADO' : '❌ ngsw.json NO ENCONTRADO');
                if (response.ok) return response.json();
            })
            .then(config => {
                if (config) console.log('⚙️ Configuración NGSW:', config);
            })
            .catch(() => console.log('❌ Error accediendo a ngsw.json'))
            .then(() => {
                if ('serviceWorker' in navigator) {
                    return navigator.serviceWorker.getRegistrations().then(registrations => {
                        console.log('📋 Service Workers registrados:', registrations.length);
                        if (registrations.length === 0) {
                            return navigator.serviceWorker.register('/ngsw-worker.js')
                                .then(reg => {
                                    console.log('✅ Registro manual exitoso:', reg);
                                    setTimeout(() => {
                                        navigator.serviceWorker.getRegistrations().then(newRegs => {
                                            console.log('📋 Service Workers después del registro:', newRegs.length);
                                        });
                                    }, 1000);
                                })
                                .catch(err => {
                                    console.log('❌ Error en registro manual:', err);
                                });
                        }
                    });
                }
            });
    }
}